import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RxUploadZoneComponent } from './rx-upload-zone.component';
import { DragDropDirective } from './drag-drop.directive';
import { RxIconModule } from '@nrwl/rx-icon';
import { RxButtonModule } from '@nrwl/rx-button';

@NgModule({
  imports: [CommonModule, RxIconModule, RxButtonModule, RxUploadZoneComponent, DragDropDirective],
  exports: [RxUploadZoneComponent, DragDropDirective],
})
export class RxUploadZoneModule {}
